import "../utility.css"

import Img1 from "../../../assets/images/hearingTestPage/1.jpg"
import icon from "../../../assets/images/testicon.svg"
import NavigationBar from "../../../components/01_navigationBar/01_navigationBar";
import Footer from "../../../components/02_footer/02_footer";

export default function HearingLoss() {
    return (
        <div>
            <NavigationBar />
            <div className="UtilityPages-HeroSection">
                <div className="UtilityPages-HeroSection-Info">
                        <h1>Early Signs of Hearing Loss Should Never Be Ignored</h1>
                        <p>
                            Hearing loss often develops gradually, affecting conversations, confidence, and relationships over time. Early hearing tests and audiometry tests can help identify the right hearing aids before hearing difficulties worsen. Professional audiologist guidance and personalized hearing aid machine recommendations help you reconnect with everyday sounds and conversations.
                        </p>
                </div>
                <img src={Img1} alt="" />
            </div>
            <div className="UtilityPages-CardTypeOne-Section">
                <div className="UtilityPages-CardTypeOne-Section-Info">
                    <h2>Common Signs to Watch For</h2>
                </div>
                <div className="UtilityPages-CardTypeOne-Section-Flex">
                    <div className="UtilityPages-CardTypeOne-Section-Card">
                        <img src={icon} alt="" />
                        <p>
                            Frequently asking people to repeat themselves
                        </p>
                    </div>
                    <div className="UtilityPages-CardTypeOne-Section-Card">
                        <img src={icon} alt="" />
                        <p>
                            Difficulty hearing in noisy environments
                        </p>
                    </div>
                    <div className="UtilityPages-CardTypeOne-Section-Card">
                        <img src={icon} alt="" />
                        <p>
                            Trouble hearing alarms or high-pitched sounds
                        </p>
                    </div>
                    <div className="UtilityPages-CardTypeOne-Section-Card">
                        <img src={icon} alt="" />
                        <p>
                            Feeling like others are mumbling
                        </p>
                    </div>
                    <div className="UtilityPages-CardTypeOne-Section-Card">
                        <img src={icon} alt="" />
                        <p>
                            Increasing TV or phone volume often
                        </p>
                    </div>
                </div>
            </div>
            <div className="UtilityPages-BulletsTypeTwo-Section">
                <div className="UtilityPages-BulletsTypeTwo-Section-Info">
                    <h2>Social & Emotional Indicators</h2>
                </div>
                <div className="UtilityPages-BulletsTypeTwo-Section-Flex">
                    <div className="UtilityPages-BulletsTypeTwo-Section-Bullet">
                        <img src={icon} alt="" />
                        <p>
                            Avoiding social gatherings
                        </p>
                    </div>
                    <div className="UtilityPages-BulletsTypeTwo-Section-Bullet">
                        <img src={icon} alt="" />
                        <p>
                            Misunderstanding conversations
                        </p>
                    </div>
                    <div className="UtilityPages-BulletsTypeTwo-Section-Bullet">
                        <img src={icon} alt="" />
                        <p>
                            Feeling disconnected from loved ones
                        </p>
                    </div>
                </div>
            </div>
            <div className="UtilityPages-LeftText-Section">
                <div className="UtilityPages-LeftText-Section-Info">
                    <h2>When to Get Checked</h2>
                    <p>
                        If you notice these signs, schedule a professional hearing test. Early hearing care can improve communication, confidence, and quality of life.
                    </p>
                </div>
                <img src={Img1} alt="" />
            </div>
            <div className="UtilityPages-RightText-Section">
                <img src={Img1} alt="" />
                <div className="UtilityPages-RightText-Section-Info">
                    <h2>Don’t Ignore the Signs</h2>
                    <p>
                        Hearing loss affects communication, relationships, and emotional well-being. The right hearing aids and expert support can help you feel connected and confident again.
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    );
}